var _path, _path2, _path3;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgGroup80(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 36,
    height: 80,
    viewBox: "0 0 36 80",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M2.5 77.499H33.5L28.093 60.2459L18.538 34.9657L2.5 77.499Z",
    fill: "black"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M18.538 34.9657V19.499M18.538 34.9657L2.5 77.499H33.5L28.093 60.2459L18.538 34.9657ZM6.77716 41.0074L10.0698 34.9657L18.538 19.499L27.3721 35.6509L30.2558 41.0074",
    stroke: "black",
    strokeWidth: 5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M13.5 7.99985C13.5 9.45854 14.0268 10.8575 14.9645 11.8889C15.9021 12.9204 17.1739 13.4999 18.5 13.4999C19.8261 13.4999 21.0979 12.9204 22.0355 11.8889C22.9732 10.8575 23.5 9.45854 23.5 7.99985C23.5 6.54116 22.9732 5.14222 22.0355 4.11077C21.0979 3.07932 19.8261 2.49985 18.5 2.49985C17.1739 2.49985 15.9021 3.07932 14.9645 4.11077C14.0268 5.14222 13.5 6.54116 13.5 7.99985Z",
    fill: "black",
    stroke: "black",
    strokeWidth: 5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgGroup80);
export default __webpack_public_path__ + "static/media/Group 80.af497a11c126fafae8a9b07fc8d1ea24.svg";
export { ForwardRef as ReactComponent };